// SubmitForm_new.jsx (both the offline-Challan-submission branch and the online-payment branch — the
// embedded <Payments> (PaymentsIOBCCAvenue.jsx) component itself is not covered here; only this file's
// own surrounding headings/labels/checkbox text/buttons/success message are). offlineSubmitHeading and
// onlineMakePaymentHeading were already bilingual in the file, using an old "English (Marathi)"
// parenthetical format — extracted as-is, now rendered via Text's standardized single-line
// "English / मराठी" format (Stage 3.9 Task 2). formSubmittedSuccess, transactionNumberLabel,
// challanPaymentDateLabel, confirmDetailsCorrect, cancelButton, previousButton and submitButton were
// already bilingual (2-stacked-div displayInGrid format) — extractions, zero new translation authored.
// The three Challan_Transaction_Id/Challan_Payment_Date validate() messages had no existing Marathi
// anywhere in the file — AI-authored, needs linguistic QA.
export default {
  offlineSubmitHeading: { en: 'Submit Form', mr: 'फॉर्म जमा करा' },
  onlineMakePaymentHeading: { en: 'Make Payment', mr: 'पेमेंट करा' },
  formSubmittedSuccess: { en: 'Form submitted successfully.', mr: 'फॉर्म यशस्वीरित्या जमा झाला.' },
  transactionNumberLabel: { en: 'Transaction Number', mr: 'व्यवहार क्रमांक' },
  challanPaymentDateLabel: { en: 'Challan Payment Date', mr: 'चलन भरण्याची तारीख' },
  confirmDetailsCorrect: {
    en: 'Yes, I confirm all my details are correct.',
    mr: 'होय, मी माझे सर्व तपशील बरोबर असल्याची पुष्टी करतो.'
  },
  cancelButton: { en: 'Cancel', mr: 'रद्द करा' },
  previousButton: { en: 'Previous', mr: 'मागे' },
  submitButton: { en: 'Submit', mr: 'जमा करा' },
  // AI-authored, needs linguistic QA
  invalidTransactionId: {
    en: 'Please enter valid Challan Transaction ID',
    mr: 'कृपया वैध चलन व्यवहार आयडी प्रविष्ट करा'
  },
  // AI-authored, needs linguistic QA
  invalidTransactionNumber: {
    en: 'Please enter valid Challan Transaction Number',
    mr: 'कृपया वैध चलन व्यवहार क्रमांक प्रविष्ट करा'
  },
  // AI-authored, needs linguistic QA
  invalidChallanPaymentDate: {
    en: 'Please enter valid Challan Payment Date',
    mr: 'कृपया वैध चलन भरण्याची तारीख प्रविष्ट करा'
  },
  // Phase C.5 (Candidate System UI Language Migration): 2 residual hardcoded literals discovered
  // during that phase's re-inventory of this otherwise already-migrated file. challanTransactionIdLabel
  // was already bilingual in the file (extraction, zero new translation authored).
  challanTransactionIdLabel: { en: 'Challan Transaction ID', mr: 'चलन व्यवहार आयडी' },
  // The BoxInput.jsx shared control's own hardcoded fallback validation message (used when a caller
  // passes no errorMessage) — the file's original Marathi half was itself a mixed English+Marathi
  // string ("Transaction Number हा ६ अंकी असावा"); a clean Marathi-only translation is authored here
  // instead of extracting the mixed original verbatim — AI-authored, needs linguistic QA.
  transactionNumberDigitsError: { en: 'Transaction Number should be of 6 digits', mr: 'व्यवहार क्रमांक ६ अंकी असावा' },
  // PaymentsIOBCCAvenue.jsx's own "Payment" trigger button — already bilingual in the file
  // (extraction, zero new translation authored). Distinct from onlineMakePaymentHeading above (which
  // is this same page's "Make Payment" section heading, not this button's own text).
  paymentButton: { en: 'Payment', mr: 'पेमेंट करा' }
};
